
// in ./MyLayout.js
import React from 'react';
import { Layout, Sidebar } from 'react-admin';
import NewAppBar from './new-app-bar.js';
import Menu from './menu.js'
const NewSidebar = props => <Sidebar {...props} size={300} />;
const NewLayout = props => <Layout {...props} sidebar={NewSidebar} appBar={NewAppBar} menu={Menu}/>;

export default NewLayout;